import { Collapse } from "antd";
import React from "react";
import { getColor } from "../util/CC";
import Html from "../components/utilities/Html";
import { useMediaQuery } from "react-responsive";
import { CaretRightOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

export default function Accordion(props) {
    const template = window.sitesettings.template_info;
    const ismobile = useMediaQuery({ query: '(max-width: 716px)' })    

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = props.content;

    const {
        label = "FAQ",
        width = 1248,
        has_width = false,
        label_preset = 0,
        header_preset = 0,
        align = "center",
        is_accordion = false,
        is_ghost = false,
        paragraph_background = 0,
        paragraph_preset = 0,
        background_colour = 0,
        arrow_colour = 0,
        arrow_size = 15,
        padding_x = 10,
        padding_y = 10,
        faq = [
            { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit."},
            { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit."},
            { headline: "Headline", label: "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit."},
        ],
        
        allow_mobile_overrides = false,
        mobile_arrow_size = 15,
        link_id = 0,

    } = data;

    const drawRender = () => {

        const m = (allow_mobile_overrides && ismobile) ? true : false;

        const _style = {
            background: getColor(background_colour, template),
            width: (has_width && !m) ? width + "px" : "100%",
            margin: (align === "center") ? "0 auto" : (align === "right") ? "0 0 0 auto" : "initial",
            padding: `${padding_y}px ${padding_x}px`,
        }

        return (
            <div className={(container) ? "preview-container" : ""}>
                <div style={_style}>
                    {(label &&
                        <h2 style={{ "display": "block" }} className={"bm-txt-" + label_preset} >
                            {label}
                        </h2>
                    )}
                    <Collapse 
                        style={{ "display": "block" }} 
                        accordion={is_accordion}
                        ghost={is_ghost}
                        className={"antd-accordion"}
                        expandIcon={({ isActive }) => <CaretRightOutlined style={{fontSize: m ? `${mobile_arrow_size}px` : `${arrow_size}px`, color: getColor(arrow_colour, template)}} rotate={isActive ? 90 : 0} />}
                    >
                        {faq.map((item, index) => (
                            <Panel 
                                className={`bm-${is_ghost ? "txt" : "btn"}-${header_preset}`}
                                header={<span>{item.headline}</span>}
                                key={index}
                            >
                                <div style={{background: getColor(paragraph_background, template)}}>
                                    <div className={"bm-txt-" + paragraph_preset}>
                                        <Html className={"bm-lnkin-" + link_id} html={item.paragraph} />
                                    </div>
                                </div>
                            </Panel>
                        ))}
                    </Collapse>
                </div>
            </div>
        )
    }
    
    return drawRender();
}